import Toastify from 'toastify-js';

/**
 * Show notice 
 * 
 * @param {string} text                      - Message
 * @param {'default'|'error'|'warning'} type - Notice type 
 * @param {Record<string, string>} options   - Toastify options
 */
export function notice(text = '', type = 'default', options = {}) {
    if (!text) {
        return;
    }
    const span = document.createElement('span');
    span.innerHTML = text;

    const defaultOptions = {
        duration: 4000,
        node: span,
        className: `toastify--${type}`,
        close: false,
        gravity: "bottom", // `top` or `bottom`
        position: "right", // `left`, `center` or `right`
        stopOnFocus: true, // Prevents dismissing of toast on hover
    };

    Object.assign(defaultOptions, options);
    Toastify(defaultOptions).showToast();
}
